export const MaximumMaterialsLimit = 350

export const ModelSpreadsheetUrl = `${process.env.REACT_APP_DOWNLOAD_FILES_BASE_URL}/modelo_novo_upload_de_planilhas.xlsx`
